<template>
    <div class="bottom-nav">
        <router-link to="/dashboard" v-slot="{ isActive }">
            <span>
                <i class="fa fa-house" :class="{ 'active-icon': isActive }"></i>
            </span>
            <small>Dashboard</small>
        </router-link>

        <router-link to="/ticket" :class="{ 'router-link-active': isTicketsActive }">
            <span><i class="fa fa-wrench" :class="{ 'active-icon': isTicketsActive }"></i></span>
            <small>Tickets</small>
        </router-link>

        <router-link to="/meetings" v-slot="{ isActive }">
            <span><i class="fa fa-calendar-alt" :class="{ 'active-icon': isActive }"></i></span>
            <small>Meetings</small>
        </router-link>

        <router-link to="/expenses"
                     :class="{ 'router-link-active': isExpensesActive }">
            <span>
                <i class="fa fa-file-invoice-dollar" :class="{ 'active-icon': isExpensesActive }"></i>
            </span>
            <small>Expenses</small>
        </router-link>

        <router-link to="/voting-proposals" v-slot="{ isActive }">
            <span>
                <i class="fa fa-store" :class="{ 'active-icon': isActive }"></i>
            </span>
            <small>Votes</small>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'MobileBottomNav',
    computed: {
        isTicketsActive() {
            return this.$route.path === '/ticket' || this.$route.path.startsWith('/viewTicket/');
        },
        isExpensesActive() {
            return this.$route.path.startsWith('/expenses');
        }
    }
};
</script>
